<div class="card-container" [style.backgroundColor]="backgroundColor">
  <!-- card header -->
  <div class="card-header">
    <h3>{{cardHeaderLabel}}</h3>
  </div>

  <!-- card content -->
  <div class="card-content">
    <!-- left-content -->
    <div class="left-content">
      <h2>{{statisticsPercent | numberFormat}} {{statisticsLabel}}</h2>
      <h4 [attr.percentage]="percentage>=0 ? 'up' : 'down'">
        {{Math.abs(percentage) | numberFormat}}%
        <mat-icon>{{percentage >= 0 ? 'arrow_upward' : 'arrow_downward' }}</mat-icon>
        <span class="ellipsis">{{"WHITE_LABEL_DASHBOARD.STATISTICS_CARD.COMPARED_TO" | translate}}</span>
      </h4>
    </div>

    <!-- right-content -->
    <div class="right-content">
      <div class="img">
        <img
          [src]="percentage >= 0 ? '../../../../../../assets/images/upgrade-chart.svg' : '../../../../../../assets/images/downgrade-chart.svg'"
          alt="chart"
        />
      </div>
    </div>
  </div>
</div>
